/**
 * Returns the items from `a` that are not in `b`. This function accepts an
 * `iteratee` which is invoked for each element of `a` and `b` to generate the
 * criterion by which they're compared. The `iteratee` is invoked with one
 * argument. Comparison uses strict equality (`===`)
 *
 * @param a The source array to remove items from
 * @param b The array of items to remove
 * @param iteratee
 */

function differenceBy<T>(
  a: T[],
  b: T[],
  iteratee: (x: T) => any,
): T[] {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return [];
  }
  return a.filter(
    (objA) => !b.some(
      (objB) => iteratee(objA) === iteratee(objB),
    ),
  );
}

export default differenceBy;
